import { useI18n } from '@app-velocity/i18n';
import { MessageBus } from '@app-velocity/message-bus';

import { StyledLinkToEdit, StyledDataSection, SectionHeading } from '../styled';

const messageBus = new MessageBus('users');

export const PasswordSection = () => {
  const { t } = useI18n();

  const clickHandler = () => {
    messageBus.publish('modal:change-password:open');
  };

  return (
      <StyledDataSection>
        <SectionHeading>{t('users:password')}</SectionHeading>
        <StyledLinkToEdit onClick={clickHandler}>
          {t('users:settings.change_password')}
        </StyledLinkToEdit>
      </StyledDataSection>
  );
};
